import React from 'react';
import { Typography } from '@mui/material';
import styled from '@emotion/styled';

const Root = styled.div(({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100%;
  color: white;
  background: linear-gradient(
    to right,
    ${theme.palette.primary.main} 50%,
    ${theme.palette.primary.light}
  );
`);

const DisplayArea = styled.div(({ theme }) => `
  min-width: ${theme.maxToolWidth};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.typography.pxToRem(48)} ${theme.typography.pxToRem(87)};
  gap: 2rem;

  @media (max-width: 1200px) {
    min-width: 0;
    width: 100%;
    padding: ${theme.typography.pxToRem(32)} ${theme.typography.pxToRem(43.5)};
  }

  @media (max-width: 600px) {
    padding: 1.5rem 1rem;
    flex-direction: column;
    align-items: flex-start;
  }
`);

const TextContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
});

const ImageWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  color: 'white',
  opacity: 0.85,
});

export interface GradientBannerProps {
  header: string;
  description?: string;
  image?: React.ReactNode;
  imageAlt?: string;
  className?: string;
}

export default function GradientBanner({
  header,
  description,
  image,
  className,
}: GradientBannerProps): React.ReactElement {
  return (
    <Root className={className}>
      <DisplayArea>
        <TextContent>
          <Typography variant="h1" color="inherit">
            {header}
          </Typography>
          {description && (
            <Typography variant="body1" color="inherit">
              {description}
            </Typography>
          )}
        </TextContent>
        {image && <ImageWrapper>{image}</ImageWrapper>}
      </DisplayArea>
    </Root>
  );
}
